import { css } from '@emotion/core';
import { MediaQueries } from '../../../../styles/Grid';

export const containerSizesShop = {
  background: '#f4f3f0 !important',
  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '0px',
  },
};

export const itemsContainerCss = css({
  paddingBottom: '0px',
  paddingTop: '0px',
  [MediaQueries.lg]: {
    width: 'calc(100% - 44px)',
  },

  [MediaQueries.xl]: {
    width: 'calc(100% - 64px)',
  },
  [MediaQueries.md]: {
    width: 'calc(100% - 48px)',
  },

  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '0px',
  },

  '.booknowflex': {
    display: 'flex',
    '.findoutlink': {
      marginRight: '16px',
    },
  },

  '.grid-item-2': {
    h2: {
      fontSize: '48px',
      lineHeight: '56px',
      textAlign: 'left',
      fontWeight: '500',
      color: '#393939',
      [MediaQueries.sm]: {
        fontSize: '28px',
        lineHeight: '40px',
      },
      [MediaQueries.md]: {
        fontSize: '28px',
        lineHeight: '40px',
        letterSpacing: '-0.3px,',
      },
      [MediaQueries.lg]: {
        fontSize: '34px',
        lineHeight: '40px',
        letterSpacing: '-1px',
      },
    },

    '.leftseccontent:hover': {
      cursor: 'pointer',
      borderColor: 'transparent',
      boxShadow: '0px 10px 80px rgb(0 0 0 / 8%)',
      outline: '0',
    },

    '.leftseccontent': {
      padding: '48px 40px',
      background: '#fff',
      borderRadius: '16px',
      minHeight: '384px',

      [MediaQueries.sm]: {
        padding: '34px 24px',
        marginBottom: '24px',
        width: '100%',
        minHeight: 'auto',
      },

      [MediaQueries.md]: {
        minHeight: '464px',
        width: '100%',
        padding: '34px 28px',
      },
      [MediaQueries.lg]: {
        minHeight: '384px',
        width: '100%',
        padding: '48px 24px',
      },

      img: {
        maxWidth: '48px',
      },
    },

    '.findoutlink': {
      color: '#E52500',
      position: 'absolute',
      bottom: '48px',
      display: 'flex',

      [MediaQueries.md]: {
        display: 'flex',
        flexDirection: 'column',
        bottom: '20px',
      },

      [MediaQueries.sm]: {
        display: 'inline-grid',
        position: 'relative',
        bottom: 'auto',
      },

      a: {
        color: '#E52500',
        textDecoration: 'none',
        marginRight: '15px',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '32px',
        textAlign: 'left',
        [MediaQueries.sm]: {
          fontSize: '16px',
          lineHeight: '24px',
        },
      },
    },
  },

  '.grid-item-3': {
    h2: {
      fontSize: '40px',
      lineHeight: '48px',
      textAlign: 'left',
      fontWeight: '500',
      letterSpacing: '-0.3px',
      color: '#393939',
      [MediaQueries.sm]: {
        fontSize: '28px',
        lineHeight: '40px',
        letterSpacing: '-0.4px',
      },
      [MediaQueries.md]: {
        fontSize: '34px',
        lineHeight: '40px',

        maxWidth: '495px',
      },
      [MediaQueries.lg]: {
        fontSize: '34px',
        lineHeight: '40px',
        letterSpacing: '-1px',
      },
    },

    '.sec1:last-child': {
      [MediaQueries.md]: {},

      '.leftseccontent': {
        [MediaQueries.md]: {
          marginBottom: '0px',
        },
        '.findoutlink': {
          [MediaQueries.md]: {
            bottom: '10px',
          },
        },
      },
    },

    '.sec1': {
      [MediaQueries.md]: {
        width: '100%',
      },

      '.leftseccontent:hover': {
        cursor: 'pointer',
        borderColor: 'transparent',
        boxShadow: '0px 10px 80px rgb(0 0 0 / 8%)',
        outline: '0',
      },

      '.leftseccontent': {
        padding: '40px 40px',
        background: '#fff',
        borderRadius: '16px',
        minHeight: '416px',
        [MediaQueries.sm]: {
          padding: '34px 24px',
          marginBottom: '24px',
          width: '100%',
          minHeight: 'auto',
        },

        [MediaQueries.md]: {
          minHeight: '216px',
          width: '100%',
          marginBottom: '32px',
        },
        [MediaQueries.lg]: {
          minHeight: '464px',
          width: '100%',
          padding: '40px 32px',
        },

        img: {
          maxWidth: '48px',
          [MediaQueries.md]: {},
        },
      },
    },

    '.findoutlink': {
      color: '#E52500',
      position: 'absolute',
      bottom: '40px',
      display: 'flex',
      flexDirection: 'row',

      [MediaQueries.md]: {
        display: 'flex',
        flexDirection: 'row',
        bottom: '40px',
      },

      [MediaQueries.lg]: {
        display: 'flex',
        flexDirection: 'column',
        bottom: '40px',
      },

      [MediaQueries.sm]: {
        display: 'inline-grid',
        position: 'relative',
        bottom: 'auto',
      },

      a: {
        color: '#E52500',
        textDecoration: 'none',
        marginRight: '15px',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '32px',
        textAlign: 'left',
        [MediaQueries.lg]: {
          marginBottom: '20px',
        },
        [MediaQueries.md]: {
          marginBottom: '20px',
          fontSize: '16px',
        },
        [MediaQueries.sm]: {
          fontSize: '16px',
        },
      },

      'a:last-child:': {
        marginBottom: '0px',
      },
    },
  },

  '.mdsection': {
    width: '100%',
    borderRadius: '16px',
    paddingTop: '16px',
    paddingBottom: '16px',
    marginLeft: '0px',
    marginRight: '0px',
    [MediaQueries.sm]: {
      width: 'auto',
      paddingTop: '0px',
      paddingBottom: '0px',
    },

    '.sec1:last-child': {
      h2: {
        span: {
          // color: '#33A2A4',
        },
      },
    },

    '.sec1': {
      display: 'flex',
      paddingLeft: '16px',
      paddingRight: '16px',
      [MediaQueries.sm]: {
        paddingLeft: '0px',
        paddingRight: '0px',
      },
      [MediaQueries.md]: {
        paddingLeft: '12px',
        paddingRight: '12px',
      },
      [MediaQueries.lg]: { paddingLeft: '12px', paddingRight: '12px' },
    },

    h2: {
      textAlign: 'left',
      fontWeight: '500',
      marginTop: '24px',
      [MediaQueries.sm]: {
        minHeight: 'auto',
        marginTop: '16px',
      },
      [MediaQueries.md]: {
        minHeight: '160px',
        letterSpacing: 'unset',
      },
      [MediaQueries.lg]: {
        minHeight: '160px',
      },

      span: {
        // color: '#33A2A4',
      },
    },

    p: {
      fontSize: '18px',
      fontStyle: 'normal',
      marginTop: '16px',
      fontWeight: 400,
      lineHeight: '32px',
      letterSpacing: '0px',
      textAlign: 'left',
      color: '#747475',
    },
  },
});
